import { getIndustryPreviewConfig } from "./previewIndustryConfig";

export default function GeneratorHeroPreview({ form, previewSeed }) {
    const config = getIndustryPreviewConfig(form, previewSeed);

    return (
        <div className="wg-hero-preview">
            <div className="wg-hero-preview-copy">
                <div className="wg-hero-preview-badge">Live Generator Preview</div>

                <h3 className="wg-hero-preview-title">{config.headline}</h3>

                <p className="wg-hero-preview-subtitle">{config.subtitle}</p>

                <div className="wg-hero-preview-actions">
                    <button type="button" className="wg-btn primary" disabled>
                        {config.primaryCta}
                    </button>
                    <button type="button" className="wg-btn secondary" disabled>
                        {config.secondaryCta}
                    </button>
                </div>

                <div className="wg-hero-preview-tags">
                    <span>{config.industry || "Industry"}</span>
                    <span>{config.goal || "Goal"}</span>
                    <span>{config.brandStyle || "Brand Style"}</span>
                </div>
            </div>

            <div className="wg-hero-preview-visual">
                <div className="wg-hero-preview-window">
                    <div className="wg-hero-preview-topbar">
                        <span />
                        <span />
                        <span />
                    </div>

                    <div className="wg-hero-preview-body">
                        <div className="wg-hero-preview-sidebar">
                            <div />
                            <div />
                            <div />
                            <div />
                        </div>

                        <div className="wg-hero-preview-main">
                            <div className="wg-hero-preview-main-hero" />
                            <div className="wg-hero-preview-main-grid">
                                <div />
                                <div />
                                <div />
                            </div>

                            <div className="wg-hero-preview-page-row">
                                {config.pages.map((page) => (
                                    <span key={page}>{page}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}